export { default as SmallSizeGuideHeader } from "./SmallSizeGuideHeader";
